import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OrganisationManuscriptProcessingPage } from "~/pages/settings/organisations/organisation/manuscript-processing/organisation-manuscript-processing-page";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId/manuscript-processing",
)({
  head: () => ({
    meta: [{ title: i18n.t("general:documentTitle.manuscriptProcessing") }],
  }),
  component: OrganisationManuscriptProcessingPage,
});
